import { Link } from 'react-router-dom'

import carbon from '@/assets/images/services/carbon.webp'
import { Button } from '@/components/button'
import { BiomeIntegrationIcon } from '@/components/icons/services/carbon/biome-integration'
import { CarbonEmissionIcon } from '@/components/icons/services/carbon/carbon-emission'
import { CertificateIcon } from '@/components/icons/services/carbon/certificate'
import { ContinuousMonitoringIcon } from '@/components/icons/services/carbon/continuous-monitoring'

import * as Card from '../../components/services-sections/card'
import * as Section from '../../components/services-sections/root'

export function CarbonSection() {
  return (
    <section className="flex flex-col">
      <Section.ContainerRoot>
        <Section.Image src={carbon} />
        <Section.Container>
          <Section.Title>Carbono</Section.Title>
          <Section.Description>
            <Section.DescriptionBold>
              Transformamos reduções reais de emissões em créditos de carbono
              certificados, com tecnologia orbital, algoritmos exclusivos e
              rastreabilidade total via blockchain.
            </Section.DescriptionBold>{' '}
            Projetos auditáveis, livres de dupla contagem, com monitoramento e
            integração a iniciativas de preservação, regeneração e amortecimento
            ambiental.
          </Section.Description>
        </Section.Container>
      </Section.ContainerRoot>

      <div className="flex flex-col gap-24">
        <Card.Scroll>
          {/* Card 1 */}
          <Card.Root>
            <Card.Container icon={ContinuousMonitoringIcon}>
              <Card.Description>
                <Card.DescriptionBold>
                  Monitoramento orbital contínuo
                </Card.DescriptionBold>{' '}
                com validação por IA e blockchain
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 2 */}
          <Card.Root>
            <Card.Container icon={CarbonEmissionIcon}>
              <Card.Description>
                Reduções de emissão autênticas, permanentes e{' '}
                <Card.DescriptionBold>sem dupla contagem</Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 3 */}
          <Card.Root>
            <Card.Container icon={BiomeIntegrationIcon}>
              <Card.Description>
                Integração com projetos de{' '}
                <Card.DescriptionBold>
                  preservação, regeneração e amortecimento
                </Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 4 */}
          <Card.Root>
            <Card.Container icon={CertificateIcon}>
              <Card.Description>
                <Card.DescriptionBold>Dados certificados</Card.DescriptionBold>{' '}
                para ESG, balanço de carbono e créditos premium
              </Card.Description>
            </Card.Container>
          </Card.Root>
        </Card.Scroll>
        <Button asChild className="mx-auto max-w-96 uppercase md:w-full">
          <Link to="/carbon">Saiba mais</Link>
        </Button>
      </div>
    </section>
  )
}
